/* eslint-disable
    no-console,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class SavedSearchAndItemsBaseController {
   $scope: any
   alerts: any
   cloudStorage: any
   events: any
   i18n: any
   savedSearch: any
   constructor($scope: any, cloudStorage: any, savedSearch: any, events: any, i18n: any, alerts: any) {
      this.saveSearch = this.saveSearch.bind(this)
      this.handleError = this.handleError.bind(this)
      this.hideSpinner = this.hideSpinner.bind(this)
      this.$scope = $scope
      this.cloudStorage = cloudStorage
      this.savedSearch = savedSearch
      this.events = events
      this.i18n = i18n
      this.alerts = alerts
      this.$scope.i18n = this.i18n
      this.$scope.savedSearch = this.savedSearch.scope
      this.$scope.providers = this.cloudStorage.scope.providers

      // set scope functions
      this.$scope.saveSearch = this.saveSearch
      this.$scope.isSignedIn = this.cloudStorage.isSignedIn
      this.$scope.signedInProvider = this.cloudStorage.signedInProvider
   }

   saveSearch() {
      const {
         currentSearch
      } = this.savedSearch.scope
      if (currentSearch.saved) { return }
      this.$scope.showSpinner = true
      this.$scope.spinnerAction = this.i18n.translations.SAVING_THIS_ITEM
      return this.savedSearch.saveSearch()
         .then((result: any) => {
            const label = currentSearch.activeIdx < 0 ? 'new' : 'edit'
            const saveMsg = this.$scope.isSignedIn() ?
               this.i18n.translations.SEARCH_SAVED
               :
               this.i18n.translations.SEARCH_SAVED_FOR_SESSION
            this.alerts.toast('savedSearchSuccess', saveMsg)
            this.events.gaPush('saved search', 'saved', label)
            return this.hideSpinner()
         }).catch(this.handleError)
   }

   handleError(error: any) {
      if (error.message == 'duplicate') {      
         this.alerts.setAlert('cloudStorageApiError', this.i18n.translations.SAVE_SEARCH_DUPLICATED)
      } else if(error) {         
         this.alerts.setAlert('cloudStorageApiError', this.i18n.translations.CLOUD_STORAGE_API_ERROR + ': ' + error.name)
      } else {
         console.error('Unhandled undefined error', error)
      }
      return this.hideSpinner()
   }

   hideSpinner() {
      return this.$scope.showSpinner = false
   }
}

SavedSearchAndItemsBaseController.$inject = ['$scope', 'cloudStorageService', 'savedSearchService', 'eventService', 'translationService', 'alertService']

angular.module('summonApp.controllers')
   .controller('SavedSearchAndItemsBaseCtrl', SavedSearchAndItemsBaseController)
